module.exports = __webpack_public_path__ + "static/media/lob-about-cover.90fe43ea.jpg";